import { render, staticRenderFns } from "./fxServiceNumDetailTable.vue?vue&type=template&id=0b4cd572"
import script from "./fxServiceNumDetailTable.vue?vue&type=script&lang=js"
export * from "./fxServiceNumDetailTable.vue?vue&type=script&lang=js"
import style0 from "./fxServiceNumDetailTable.vue?vue&type=style&index=0&id=0b4cd572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports